import React, { FC, useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';
import { useActions, ReduxStore, getTmsTranslations, getTmsConfiguration, getTmsErrors } from '@trip-ux/redux-store';
import { get, isEmpty } from 'lodash';
import { labelsSelector, isLabelFetched } from '../utils';
import { Progress } from '@trip-ux/components';

export const TMSProvider: FC<{ children?: React.ReactNode }> = ({ children }) => {
  const { labels, config, tmsTranslationConfig, tmsTranslationErrors, labelsFetched } = useSelector(
    (store: ReduxStore) => ({
      labels: labelsSelector(store),
      config: store.config,
      tmsTranslationConfig: labelsSelector(store, 'translationConfig'),
      tmsTranslationErrors: labelsSelector(store, 'translationErrors'),
      labelsFetched: isLabelFetched(store)
    })
  );
  const translationConfig = get(config, 'options.translationConfig');
  const translationErrors = get(config, 'options.translationErrors');
  const translationSpace = get(config, 'options.translationSpace');
  const configuration = get(tmsTranslationConfig, 'configuration');
  const actions = useActions({ getTmsTranslations, getTmsConfiguration, getTmsErrors });
  useLayoutEffect(() => {
    if (!isEmpty(translationConfig) && isEmpty(configuration)) {
      actions.getTmsConfiguration(translationSpace, translationConfig, get(config, 'locale'));
    }
    if (!isEmpty(translationErrors) && isEmpty(tmsTranslationErrors)) {
      actions.getTmsErrors(translationSpace, translationErrors, get(config, 'locale'));
    }
    if (isEmpty(labels) && !isEmpty(get(config, 'options'))) {
      actions.getTmsTranslations(translationSpace, get(config, 'options.translation'), get(config, 'locale'));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // Don't render children until we have a config and labels have been fetched
  const hasConfig = !!config && Object.keys(config || {}).length > 0;
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return !hasConfig || !labelsFetched ? <Progress /> : <>{children}</>;
};

TMSProvider.displayName = 'TMSProvider';
export default TMSProvider;
